var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"instruction",attrs:{"hide-footer":"","centered":"","title":_vm.title}},[_c('div',{staticClass:"text-center"},[_c('h3',[_vm._t("default",[_vm._v("Some instructions would be helpful right now")])],2)]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"outline-info","block":""},on:{"click":_vm.hideModal}},[_vm._v("Got it")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-981caa50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/things/InstrModal.vue
// module id = null
// module chunks = 